module.exports = __webpack_public_path__ + "img/02-pku-logo.342ded42.png";